var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col, FormControl, InputGroup } from "react-bootstrap";
import { isFunction, omit } from "lodash";
import { ValidationInput } from "@irati/utils/validation";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import onEnter from "@irati/utils/onEnter";
import newId from "@irati/utils/id";
import ErrorText from "../ErrorText";
import HintText from "../HintText";
import { FormGroup } from "../Form";
import CharacterCountDown from "./CharacterCountDown";
import InfoTooltip from "./utils/InfoTooltip";
import { IconTypes } from "../Icon";
import { Label as LabelRegular } from "../Typography";
import ClearIconButton from "./styled/ClearIconButton";
import Label from "./styled/Label";
import { InputGroupAddon } from "./styled";
var INPUT_TYPE_TEXT = "text";
var FormItemInput = /** @class */ (function (_super) {
    __extends(FormItemInput, _super);
    function FormItemInput(props) {
        var _this = _super.call(this, props) || this;
        _this.blur = function () {
            if (isFunction(_this.input.blur))
                _this.input.blur();
        };
        _this.handleBlur = function () {
            _this.setState({ blurred: true });
            _this.validation.update();
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.state.value);
            }
        };
        _this.handleChange = function (e) {
            var value = e.target.value;
            if (value === "") {
                value = null;
            }
            _this.setState({ value: value });
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        _this.handleEnter = function (e) {
            if (_this.props.onEnter) {
                onEnter(e, function () {
                    _this.props.onEnter(e);
                });
            }
        };
        _this.resetBlur = function () {
            _this.setState({
                blurred: false,
                errorMsg: undefined
            });
        };
        _this.state = {
            blurred: false,
            value: props.value
        };
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    FormItemInput.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.blurred) {
            this.validation.update(prevProps, prevState);
        }
    };
    FormItemInput.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    FormItemInput.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ value: nextProps.value });
    };
    FormItemInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, name = _a.name, label = _a.label, type = _a.type, hint = _a.hint, hideLabel = _a.hideLabel, addon = _a.addon, clearable = _a.clearable, style = _a.style, error = _a.error, validValueText = _a.validValueText, maxLength = _a.maxLength, includeCharCountdown = _a.includeCharCountdown, tooltip = _a.tooltip, tooltipPosition = _a.tooltipPosition, customTooltip = _a.customTooltip, hideBorder = _a.hideBorder, flush = _a.flush;
        var errorMsg = this.state.errorMsg;
        var className = classNames("perkboxInput", this.props.className);
        var value = this.state.value;
        if (!value) {
            // if null/undefined => use ""
            value = "";
        }
        var inputProps = omit(this.props, [
            "id",
            "className",
            "label",
            "hint",
            "validation",
            "hideLabel",
            "onEnter",
            "clearable",
            "addon",
            "formatMessage",
            "translate",
            "includeCharCountdown",
            "customTooltip",
            "flush"
        ]);
        var isClearable = value && clearable && type && type.toLowerCase() === INPUT_TYPE_TEXT;
        var errorExists = error || errorMsg;
        var showValidValueText = validValueText && !!value && !errorExists;
        var inputStyling = __assign(__assign({}, style), { zIndex: "unset", minHeight: 48 });
        if (addon.before || addon.after) {
            inputStyling.marginTop = 0;
        }
        var noBorderStyling = { border: "none", boxShadow: "none", paddingLeft: 0 };
        var inputStyle = hideBorder ? __assign(__assign({}, inputStyling), noBorderStyling) : inputStyling;
        if (hint)
            inputStyle.marginBottom = 0;
        if (isClearable)
            inputStyle.paddingRight = 28;
        var input = (React.createElement(FormControl, __assign({ inputRef: function (c) {
                _this.input = c;
            } }, inputProps, { placeholder: getResolvedMessage(this, "placeholder"), style: inputStyle, type: type, value: value, onBlur: this.handleBlur, onChange: this.handleChange, onKeyPress: this.handleEnter })));
        return (React.createElement(FormGroup, { className: className, controlId: id || name, validationState: errorMsg ? "error" : undefined, flush: flush },
            React.createElement(Col, { hidden: hideLabel, xs: tooltip ? 10 : 12 }, label && (React.createElement(Label, { id: newId("label", id), error: errorMsg, htmlFor: name, flush: true }, getResolvedMessage(this, "label")))),
            tooltip && (React.createElement(Col, { xs: 2 },
                React.createElement(InfoTooltip, { tooltip: tooltip, position: tooltipPosition, customIcon: customTooltip }))),
            React.createElement(Col, { xs: 12 },
                addon.before || addon.after ? (React.createElement(InputGroupAddon, null,
                    addon.before && React.createElement(InputGroup.Addon, null, addon.before),
                    input,
                    addon.after && React.createElement(InputGroup.Addon, null, addon.after))) : (input),
                isClearable && React.createElement(ClearIconButton, { id: newId("btn-clear", id), size: "10", icon: IconTypes.cross, onClick: this.handleChange }),
                errorExists && (React.createElement(ErrorText, { id: newId("copy-error", id) }, getResolvedMessage(this, "errorMsg", this.state) || getResolvedMessage(this, "error"))),
                showValidValueText && React.createElement(LabelRegular, null, validValueText),
                hint && (React.createElement("div", null,
                    React.createElement(HintText, { id: newId("copy-hint", id), small: true }, hint))),
                maxLength && includeCharCountdown && (React.createElement("div", null,
                    React.createElement(CharacterCountDown, { maxLength: maxLength, value: value }))))));
    };
    FormItemInput.contextTypes = {
        currentScreen: PropTypes.string
    };
    FormItemInput.defaultProps = {
        type: INPUT_TYPE_TEXT,
        hideLabel: false,
        addon: {},
        clearable: false,
        includeCharCountdown: true,
        customTooltip: false,
        flush: false
    };
    return FormItemInput;
}(Component));
export { FormItemInput };
export default injectIntl(FormItemInput, { withRef: true });
